import React, { useState, useEffect, useCallback } from "react";
import { db } from "../firebase";
import {
  collection,
  addDoc,
  deleteDoc,
  doc,
  onSnapshot,
} from "firebase/firestore";

const AdminDeals = () => {
  const [deal, setDeal] = useState("");
  const [selectedFilter, setSelectedFilter] = useState("all");
  const [viewFilter, setViewFilter] = useState("all");
  const [deals, setDeals] = useState([]);
  const [filteredDeals, setFilteredDeals] = useState([]);

  // ✅ Memoized filter function to avoid dependency issues
  const filterDeals = useCallback((dealsList, filter) => {
    if (filter === "all") {
      setFilteredDeals(dealsList);
    } else {
      const filtered = dealsList.filter((deal) => deal.platform === filter);
      setFilteredDeals(filtered);
    }
  }, []);

  // ✅ Real-time Firestore listener
  useEffect(() => {
    const dealsCollection = collection(db, "deals");

    const unsubscribe = onSnapshot(dealsCollection, (snapshot) => {
      const fetchedDeals = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      setDeals(fetchedDeals);
      filterDeals(fetchedDeals, viewFilter);
    });

    return () => unsubscribe(); // Cleanup
  }, [filterDeals, viewFilter]);

  // ✅ Add deal to Firestore
  const handleAddDeal = async () => {
    if (!deal.trim()) {
      alert("Please enter a deal name.");
      return;
    }

    try {
      await addDoc(collection(db, "deals"), {
        name: deal.trim(),
        platform: selectedFilter,
        createdAt: new Date(),
      });
      setDeal("");
    } catch (error) {
      console.error("Error adding deal:", error);
      alert("Failed to add deal. Please check Firebase rules.");
    }
  };

  // ✅ Delete deal
  const handleRemoveDeal = async (id) => {
    try {
      await deleteDoc(doc(db, "deals", id));
    } catch (error) {
      console.error("Error removing deal:", error);
      alert("Failed to remove deal.");
    }
  };

  return (
    <div style={{ padding: "20px", maxWidth: "700px", margin: "0 auto" }}>
      <h2 style={{ marginBottom: "20px" }}>Admin: Manage Deals</h2>

      <div style={{ marginBottom: "20px", display: "flex", gap: "10px" }}>
        <input
          type="text"
          value={deal}
          onChange={(e) => setDeal(e.target.value)}
          placeholder="Enter deal name"
          style={{
            flex: 1,
            padding: "8px",
            borderRadius: "4px",
            border: "1px solid #ccc",
          }}
        />

        <select
          value={selectedFilter}
          onChange={(e) => setSelectedFilter(e.target.value)}
          style={{
            padding: "8px",
            borderRadius: "4px",
            border: "1px solid #ccc",
          }}
        >
          <option value="platform">Platform</option>
          <option value="store">Store</option>
        </select>

        <button
          onClick={handleAddDeal}
          style={{
            padding: "8px 16px",
            backgroundColor: "#4CAF50",
            color: "#fff",
            border: "none",
            borderRadius: "4px",
            cursor: "pointer",
          }}
        >
          Add Deal
        </button>
      </div>

      <div style={{ marginBottom: "20px" }}>
        <label style={{ marginRight: "10px" }}>Filter Deals to View: </label>
        <select
          value={viewFilter}
          onChange={(e) => setViewFilter(e.target.value)}
          style={{
            padding: "8px",
            borderRadius: "4px",
            border: "1px solid #ccc",
          }}
        >
          <option value="all">All Deals</option>
          <option value="platform">Platform Deals</option>
          <option value="store">Store Deals</option>
        </select>
      </div>

      <h3>Current Deals</h3>

      {filteredDeals.length === 0 ? (
        <p>No deals found.</p>
      ) : (
        <ul style={{ padding: "0", listStyle: "none" }}>
          {filteredDeals.map((deal) => (
            <li
              key={deal.id}
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "10px",
                border: "1px solid #ccc",
                borderRadius: "4px",
                marginBottom: "10px",
                backgroundColor: "#f9f9f9",
              }}
            >
              <span>
                {deal.name} <b>({deal.platform})</b>
              </span>
              <button
                onClick={() => handleRemoveDeal(deal.id)}
                style={{
                  padding: "5px 10px",
                  backgroundColor: "#f44336",
                  color: "#fff",
                  border: "none",
                  borderRadius: "4px",
                  cursor: "pointer",
                }}
              >
                Remove
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default AdminDeals;
